import {
  IFetchAddressByPincodePayload,
  IFetchAddressByPincodeAction,
  IExecuteFunctionInStringAction,
  IExecuteFunctionInStringActionPayload,
  IFetchCountryActionPayload,
  IFetchCountryAction,
  IFetchStateAction,
  IFetchStateActionPayload,
  IFetchCityActionPayload,
  IFetchCityAction,
  IUpdateConfigActionPayload,
  IUpdateConfigAction,
  ILoadingData,
  ISetLoaderAction,
} from "@common/redux/common/interface";

const prefix = "common/";

export const commonActions = {
  FETCH_ADDRESS_BY_PINCODE: `${prefix}FETCH_ADDRESS_BY_PINCODE`,
  TOGGLE_LEFT_NAVIGATION_BAR_VISIBLITY: `${prefix}TOGGLE_LEFT_NAVIGATION_BAR_VISIBLITY`,
  EXECUTE_FUNCTION_IN_STRING: `${prefix}EXECUTE_FUNCTION_IN_STRING`,
  UPDATE_CONFIG: `${prefix}UPDATE_CONFIG`,
  FETCH_COUNTRY: `${prefix}FETCH_COUNTRY`,
  // FETCH_COUNTRY_SUCCESS: `${prefix}FETCH_COUNTRY_SUCCESS`,
  // FETCH_COUNTRY_FAILURE: `${prefix}FETCH_COUNTRY_FAILURE`,

  FETCH_STATE: `${prefix}FETCH_STATE`,
  // FETCH_STATE_SUCCESS: `${prefix}FETCH_STATE_SUCCESS`,
  // FETCH_STATE_FAILURE: `${prefix}FETCH_COUNTRY_FAILURE`,

  FETCH_CITY: `${prefix}FETCH_CITY`,
  // FETCH_CITY_SUCCESS: `${prefix}FETCH_CITY_SUCCESS`,
  // FETCH_CITY_FAILURE: `${prefix}FETCH_CITY_FAILURE`,
  SET_LOADER: `${prefix}SET_LOADER`,
};

export const fetchAddressByPincodeAction = (
  payload: IFetchAddressByPincodePayload
): IFetchAddressByPincodeAction => {
  return {
    type: commonActions.FETCH_ADDRESS_BY_PINCODE,
    payload,
  };
};

export const toggleNavigationBarVisiblityAction = (isVisible: boolean) => {
  return {
    type: commonActions.TOGGLE_LEFT_NAVIGATION_BAR_VISIBLITY,
    payload: isVisible,
  };
};

export const executeFunctionInStringAction = (
  payload: IExecuteFunctionInStringActionPayload
): IExecuteFunctionInStringAction => {
  return {
    type: commonActions.EXECUTE_FUNCTION_IN_STRING,
    payload,
  };
};

export const fetchCountryListAction = (
  payload: IFetchCountryActionPayload
): IFetchCountryAction => {
  return {
    type: commonActions.FETCH_COUNTRY,
    payload,
  };
};

// export const fetchCountryListSuccessAction = (countryList: ICountrySelectOption[]) => {
//   return {
//     type: commonActions.FETCH_COUNTRY_SUCCESS,
//     payload: {
//       countryList,
//     },
//   };
// };

// export const fetchCountryListFailureAction = (error: string) => {
//   return {
//     type: commonActions.FETCH_COUNTRY_FAILURE,
//     payload: {
//       error,
//     },
//   };
// };

export const fetchStateListAction = (
  payload: IFetchStateActionPayload
): IFetchStateAction => {
  return {
    type: commonActions.FETCH_STATE,
    payload,
  };
};

// export const fetchStateListSuccessAction = (stateList: IStateSelectOption[]) => {
//   return {
//     type: commonActions.FETCH_STATE_SUCCESS,
//     payload: {
//       stateList,
//     },
//   };
// };

// export const fetchStateListFailureAction = (error: string) => {
//   return {
//     type: commonActions.FETCH_STATE_FAILURE,
//     payload: {
//       error,
//     },
//   };
// };

export const fetchCityListAction = (
  payload: IFetchCityActionPayload
): IFetchCityAction => {
  return {
    type: commonActions.FETCH_CITY,
    payload,
  };
};

export const updateConfigAction = (
  payload: IUpdateConfigActionPayload
): IUpdateConfigAction => {
  return {
    type: commonActions.UPDATE_CONFIG,
    payload,
  };
};

// export const fetchCityListSuccessAction = (cityList: ICitySelectOption[]) => {
//   return {
//     type: commonActions.FETCH_CITY_SUCCESS,
//     payload: {
//       cityList,
//     },
//   };
// };

// export const fetchCityListFailureAction = (error: string) => {
//   return {
//     type: commonActions.FETCH_CITY_FAILURE,
//     payload: {
//       error,
//     },
//   };
// };



export const setLoaderDataAction = (
  payload: ILoadingData
): ISetLoaderAction => {
  return {
    type: commonActions.SET_LOADER,
    payload,
  };
};
